import { Component, effect, inject, signal } from '@angular/core';
import { I18nPipe } from '../../shared/i18n/i18n-pipe';
import { I18nScopeReadyDirective } from '../../shared/i18n/i18n-scope-ready.directive';
import { provideI18nScope } from '../../shared/i18n/i18n-scope.provider';
import { I18nScopedService } from '../../shared/i18n/i18n-scoped.service';
import { DashboardService } from '../dashboard/services/dashboard/dashboard.service';
import { Router } from '@angular/router';
import { DashboardListItem } from '../dashboard/models/dashboard-list-item/dashboard-list-item.model';

@Component({
  selector: 'app-overview-landing',
  imports: [I18nPipe, I18nScopeReadyDirective],
  templateUrl: './overviews-landing.html',
  styleUrls: ['./overviews-landing.scss'],
  providers: [
    provideI18nScope('features/overviews-landing'),
    I18nScopedService,
  ],
})
export class OverviewsLanding {
  private readonly dashboardService = inject(DashboardService);
  private readonly router = inject(Router);
  overviews: DashboardListItem[] = [];
  loading = signal<boolean>(true);

  constructor() {
    effect(() => {
      const loaded = this.dashboardService.dashboardListLoaded();
      const allDashboards = this.dashboardService.dashboardList();

      if (!loaded) return;

      this.overviews = allDashboards.filter(
        (dashboard) => dashboard.isOverview === true,
      );
      this.loading.set(false);

      if (this.overviews.length > 0) {
        this.router.navigateByUrl('/overview/' + this.overviews[0].name);
      }
    });
  }
}
